export const PhoneFrame = ({ src, alt, className = "" }) => (
  <div className={`relative rounded-[2.4rem] border border-cream/15 bg-[#0b0b0d] p-[7px] shadow-[0_40px_80px_-20px_rgba(0,0,0,0.8)] ${className}`}>
    <div className="relative aspect-[375/812] overflow-hidden rounded-[2rem] bg-white">
      <img src={src} alt={alt} loading="lazy" className="h-full w-full object-cover object-top" />
      <span className="absolute left-1/2 top-2 h-[18px] w-[34%] -translate-x-1/2 rounded-full bg-[#0b0b0d]" />
    </div>
  </div>
);

export const TabletFrame = ({ src, alt, className = "" }) => (
  <div className={`relative rounded-[1.6rem] border border-cream/15 bg-[#0b0b0d] p-[10px] shadow-[0_50px_100px_-30px_rgba(0,0,0,0.85)] md:p-[14px] ${className}`}>
    <div className="relative aspect-[16/10] overflow-hidden rounded-[0.9rem] bg-black">
      <img src={src} alt={alt} loading="lazy" className="h-full w-full object-cover" />
    </div>
  </div>
);

export const BrowserFrame = ({ src, alt, className = "" }) => (
  <div className={`overflow-hidden rounded-[1rem] border border-cream/15 bg-[#0b0b0d] shadow-[0_50px_100px_-30px_rgba(0,0,0,0.85)] ${className}`}>
    <div className="flex items-center gap-1.5 border-b border-cream/10 px-4 py-2.5">
      {[0, 1, 2].map((i) => <span key={i} className="h-2.5 w-2.5 rounded-full bg-cream/25" />)}
      <span className="ml-3 h-4 flex-1 rounded-full bg-cream/10" />
    </div>
    <div className="aspect-[16/10] overflow-hidden bg-white">
      <img src={src} alt={alt} loading="lazy" className="h-full w-full object-cover object-top" />
    </div>
  </div>
);

export const Device = ({ device, ...p }) =>
  device === "phone" ? <PhoneFrame {...p} /> : device === "tablet" ? <TabletFrame {...p} /> : <BrowserFrame {...p} />;
